module.exports = __webpack_public_path__ + "img/komiyama.177520cc.jpg";